import { Item } from "./Nestable";
 
export const removeItem = (
    list: Item[],
    path: number[],
    childrenProps: string
): { list: Item[]; removed: Item } => {
    if (path.length === 1) {
        const removed = list[path[0]];
        return {
            list: list.filter((_, i) => i !== path[0]),
            removed
        }
    }
 
    const [index, ...rest] = path;
    const result = removeItem(list[index][childrenProps] || [], rest, childrenProps);
 
    return {
        list: list.map((item, i) =>
            i === index
                ? { ...item, [childrenProps]: result.list }
                : item
        ),
        removed: result.removed
    }
}
 
export const insertItem = (
    list: Item[],
    path: number[],
    item: Item,
    childrenProps: string
): Item[] => {
    if (path.length === 1) {
        const newList = [...list]
        newList.splice(path[0], 0, item);
        return newList;
    }
 
    const [index, ...rest] = path;
    const safeIndex = index >= list.length ? list.length - 1 : index < 0 ? 0 : index;
 
    return list.map((it, i) => {
        return i === safeIndex
            ? {
                ...it,
                [childrenProps]: insertItem(
                    it[childrenProps] || [],
                    rest,
                    item,
                    childrenProps)
 
            } : it
})
}
 
 
export const toggleCollapseAtPath = (
    list: Item[],
    path: number[],
    childrenProps: string
): Item[] => {
    if (path.length === 1) {
        return list.map((item, i) =>
            i === path[0] ? { ...item, collapsed: !item.collapsed } : item)
    }
    const [index, ...rest] = path;
    return list.map((item, i) =>
        i === index
            ? {
                ...item,
                [childrenProps]: toggleCollapseAtPath(
                    item[childrenProps] || [],
                    rest,
                    childrenProps)
            }
            : item)
}
 
export const getDepthFromPath = (path: number[]) => path.length - 1;